import { playerPlaceholder } from '../functions/player-placeholder.js';
import { swiperAvances, swiperAmenities, swiperInfraestructura } from '../functions/swiperInit.js';
import { mapaInit } from '../functions/mapa.js';

document.addEventListener("DOMContentLoaded", () => {

    playerPlaceholder();
    swiperAvances();
    swiperAmenities();
    swiperInfraestructura();
    mapaInit();

});
